import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useContext } from 'react';

export default function useResponsive() {
  const { deviceType } = useContext(ResponsiveContext);
  const isPc = deviceType === EPlatform.WEB;
  const isAndroid = deviceType === EPlatform.ANDROID;
  const isIOS = deviceType === EPlatform.IOS;
  return {
    isPc,
    isAndroid,
    isIOS,
    isMobile: !isPc,
  };
}
